const formatRawTime = (value) => {
  if (!value || value.length > 1) {
    return value;
  }

  if (parseInt(value, 10) <= 2) {
    return value;
  }

  return `0${value}:`;
};

export default formatRawTime;
